var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableExport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.80542 0H14.4433C15.4453 0 16.2487 0.827027 16.2487 1.83784V8.34378C14.8495 8.10486 13.4684 8.43568 12.349 9.18919H9.02708V12.8649H10.002C9.90271 13.4897 9.90271 14.1054 10.002 14.7027H1.80542C0.812437 14.7027 0 13.8849 0 12.8649V1.83784C0 0.827027 0.812437 0 1.80542 0ZM1.80542 3.67568V7.35135H7.22166V3.67568H1.80542ZM9.02708 3.67568V7.35135H14.4433V3.67568H9.02708ZM1.80542 9.18919V12.8649H7.22166V9.18919H1.80542Z",
    fill: "#2D9E4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5391 12.6835L13.9535 15.3498L18.124 11.1282L17.1055 9.875L13.9535 13.0657L12.5575 11.6525L11.5391 12.6835Z",
    fill: "#2D9E4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableExport);
export default __webpack_public_path__ + "static/media/table-export.75580e3dc29379a116cccb19333c0151.svg";
export { ForwardRef as ReactComponent };